import Hidden from "./SVG/view-off.svg?react";

const HiddenIcon = ({ title }: { title?: string }) => {
  return <Hidden data-testid="hidden-icon" title={title} />;
};

export default HiddenIcon;
